module.exports = __webpack_public_path__ + "static/media/logoCuatro.7ca0647c.webp";